import { BASE_URL } from './config';

export const createStampOrder = async (body, token) => {
  try {
    const res = await fetch(`${BASE_URL}stamps/purchase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Create Stamp Order API Error:', error);
    throw error;
  }
};

export const stampPriceList = async token => {
  try {
    const res = await fetch(`${BASE_URL}stamps/pricelist`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Stamp Price List API Error:', error);
    throw error;
  }
};

export const applyVoucher = async (voucherCode, stamps, token) => {
  try {
    const res = await fetch(`${BASE_URL}stamps/vouchers/check`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ voucher_code: voucherCode, stamps }),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Apply Voucher API Error:', error);
    throw error;
  }
};
